import {
  Box,
  TableCell,
  TableRow,
  Typography,
  Card,
  Grid,
  Menu,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import {
  KeyboardArrowRight,
  KeyboardArrowDown,
  InsertDriveFileOutlined,
  DeleteOutline,
  MoreVert,
  CloudCircle,
  Delete,
  IndeterminateCheckBoxOutlined,
  AddBoxOutlined,
  Layers,
  FileCopy,
} from '@material-ui/icons';
import { DateFormat, ELMSURE, formatDate, isNil } from '@roc/feature-utils';
import { IconButton, MenuItem, Button, CopyText } from '@roc/ui';
import Chip from '@material-ui/core/Chip';
import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { observer } from 'mobx-react';
import { Fragment, useState } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  headerRow: {
    border: '1px solid #ccc',
    '& td': {
      padding: '8px',
    },
  },
  boldValues: {
    fontWeight: 'bold',
  },
}));

export const PointOfContactTableRow = observer(({ store, contact }) => {
  const classes = useStyles({});

  return (
    <Fragment key={contact.contactId}>
      <TableRow className={classes.headerRow}>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography
            >{`${contact?.firstName} ${contact.lastName}`}</Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              {contact?.email ?? '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              {contact?.phone ?? '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              {formatDate(contact?.createdDate) ?? '-'}
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box
            display={'flex'}
            alignItems={'center'}
            justifyContent="space-between"
            px={0}
            py={1}
            ml={0}
          >
            <Typography>
              <CopyText>{contact?.inviteCode ?? '-'}</CopyText>
            </Typography>
          </Box>
        </TableCell>
        <TableCell>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Button
              testId="copy-link"
              variant="outlined"
              color="primary"
              size="small"
              onClick={() => {
                store.copyLink(contact);
              }}
            >
              <FileCopy />
              Copy Link
            </Button>
          </Box>
        </TableCell>
      </TableRow>
    </Fragment>
  );
});
